import validators from 'utils/validators';

/**
 * Get validation methods as strings
 * that have a correspondng validation function
 * in `validators` and should be applied to this field.
 * @return {Array} Array of validation methods
 */
const getValidators = (field) => {
	const validator = field.validator || field.type;

	const validationMethods = [];

	if (field.required) {
		// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
		validationMethods.push('required');
	}

	if (field.noValidate) {
		return validationMethods;
	}

	switch (validator) {
		case 'email':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('email');
			break;
		case 'number':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('number');
			break;
		case 'password':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('password');
			break;
		case 'confirmpassword':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('confirmpassword');
			break;
		case 'checkboxset':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('checkboxset');
			break;
		case 'monthyear':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('monthyear');
			break;
		case 'file':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('file');
			break;
		case 'gstNumber':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('gstNumber');
			break;
		case 'tuition':
			// @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
			validationMethods.push('tuition');
			break;
	}

	return validationMethods;
};

/**
 * Get the first relevant error message for the field
 * @return {String} Error message
 */
export default function errorMessage(field, value, extraValue) {
	const validationMethods = getValidators(field);

	if (validationMethods.length) {
		const errorTypes = [];
		const isValid = validationMethods.every((validator) => {
			const check = validators[validator](value, extraValue);

			if (!check) {
				errorTypes.push(validator);
			}

			return check;
		});

		if (!isValid) {
			const msg = field.label || field.hint || 'This field';

			return validators.message(msg, errorTypes[0], value);
		}
	}

	return null;
}
